module.exports = __webpack_public_path__ + "static/media/Pollo.1622761b.jpg";